import React from 'react';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';

import { useStreamChatErrors } from '../../utils/utils';

export const InputError = () => {
  const { inputErrors } = useStreamChatErrors();

  const hasErrors = !isEmpty(inputErrors);

  if (!hasErrors) {
    return null;
  }

  return (
    <p className="help-block inline-help text-danger margin-md-top">
      {map(inputErrors, (error = {}) => {
        const { message, id } = error;
        return message ? <div key={id}>{message || null}</div> : null;
      })}
    </p>
  );
};
